import React from 'react';
import { ModificationsModalState } from './modificationsModalState/ModificationsModalState';
import { EditForm } from './components/EditForm';

interface IProps {
	onFailureEvent?: () => void;
	onCloseModal: () => void;
	onShowError: () => void;
}

export const ModificationsModal: React.FC<IProps> = ({ onFailureEvent, onCloseModal, onShowError }) => {
	return (
		<ModificationsModalState>
			<EditForm onCloseModal={onCloseModal} onFailureEvent={onFailureEvent} onShowError={onShowError} />
		</ModificationsModalState>
	);
};
